<template>
  <div>
    <!-- Navigation -->
    <nav class="navbar navbar-expand-md navbar-light bg-light">
      <div class="container">
        <a class="navbar-brand" @click="redirectURL({name:'home'})">Pubtec Publicações Tecnicas</a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarsExampleDefault">
          <ul class="navbar-nav ml-auto" style="margin-right: 15px;">
            <links-menu />
          </ul>
          <div style="margin-right: 5px; line-height: 14px; font-size: 0.8em">
            <strong style="color: #bb8a14" v-if="this.$store.state.user.person_or_company">{{this.$store.state.user.company_name}}</strong>
            <strong style="color: #bb8a14" v-else>{{this.$store.state.user.name}}</strong>
            <br>
            <small>{{ this.$store.state.user.email }} <a href="#" style="font-size: 13px" v-show="logged" @click="logout()">(sair)</a></small>

          </div>
          <div class="loggedButton">
              <a v-show="!logged" class="btn btn-primary"  @click="redirectURL({name:'login'})">Entrar</a>
          </div>
        </div>
      </div>
    </nav>
    <!-- Navigation -->
  </div>


</template>

<script>
  import auth from "../../api/auth"
  import linksMenu from "./links-menu"
  import { mapState } from 'vuex'
  import mixins from "../../helpers/mixins";
  export default {
    name: "menuDefault",
    mixins: [mixins],
    components:{ linksMenu },
    computed: mapState(['logged']),
    methods: {
      logout(){
        auth.logout()
      }
    }
  }
</script>

<style scoped>
  .navbar-brand {
    background-image: url('/img/logotipo-pubtec.png');
    height: 60px;
    width: 130px;
    background-size: cover;
    text-indent: 1000px;
    overflow: hidden;
    display: inline-block;
  }
  .navbar-nav {
    margin-right: 10px;
  }
  .navbar-nav {
    margin-right: 30px;
  }
  #navbarsExampleDefault.show .dot {
    display: none;
  }
  #navbarsExampleDefault.show .navbar-nav {
    margin: 20px 0;
  }
  #navbarsExampleDefault.show li {
    margin: 10px 0;
  }
</style>
